import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const COOKIE_NAME = "redirect_after_auth";

const useAuthRedirect = () => {
  const navigate = useNavigate();

  const storeCurrentPath = useCallback(() => {
    const currentPath = window.location.pathname;
    const inOneHour = new Date(new Date().getTime() + 60 * 60 * 1000);

    Cookies.set(COOKIE_NAME, currentPath.trim(), {
      expires: inOneHour,
      sameSite: "Lax",
    });
  }, []);

  const redirectAfterAuth = useCallback(() => {
    const redirectPath = Cookies.get(COOKIE_NAME);

    if (redirectPath) {
      Cookies.remove(COOKIE_NAME);
      navigate(redirectPath);
      return true;
    }

    return false;
  }, [navigate]);

  const wipePathCookie = useCallback(() => {
    Cookies.remove(COOKIE_NAME);

    return true;
  }, []);

  return {
    wipePathCookie,
    storeCurrentPath,
    redirectAfterAuth,
  };
};

export default useAuthRedirect;
